import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { accountSelectedSelector } from 'atoms';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import EventsActions from './EventsActions';
import EventsRows from './EventsRows';

function EventsPage() {
  const { t } = useTranslation('_common');

  const accountSelected = useRecoilValue(accountSelectedSelector);

  return (
    <Box
      sx={{
        pt: 4,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <EventsActions />
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ flex: '1 1 auto', my: 3, position: 'relative' }}
      >
        <Table stickyHeader sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={3}>{t('event')}</TableCell>
              {!accountSelected && <TableCell colSpan={2}>{t('account')}</TableCell>}
              <TableCell>{t('date')}</TableCell>
              <TableCell>{t('time')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <EventsRows {...{ accountSelected }} />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default EventsPage;
